var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticClass: "card-box block-params pfixed",
      attrs: { "body-style": { padding: 0 } }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-position": "top" } },
        [
          _c(
            "el-collapse",
            {
              model: {
                value: _vm.activeFields,
                callback: function($$v) {
                  _vm.activeFields = $$v
                },
                expression: "activeFields"
              }
            },
            [
              !!_vm.paramsConfig.rateCategories
                ? _c(
                    "div",
                    { staticClass: "mt-1 el-collapse-item" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "m-0",
                          attrs: { prop: "paramsSettings.rate_categories" }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "gray-100 semibold",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$l10n.__("Catégorie Tarifaire")) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "wp-10",
                              attrs: {
                                "data-bot": _vm.getDatabot(
                                  "select",
                                  _vm.entity,
                                  "rate-categories",
                                  _vm.sideParam
                                )
                              },
                              model: {
                                value: _vm.rateCategories,
                                callback: function($$v) {
                                  _vm.rateCategories = $$v
                                },
                                expression: "rateCategories"
                              }
                            },
                            _vm._l(_vm.rateCategoriesList, function(option) {
                              return _c("el-option", {
                                key: option.label,
                                attrs: { value: option, label: option.label }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.paramsConfig.note
                ? _c(
                    "el-collapse-item",
                    {
                      attrs: {
                        name: "note",
                        "data-bot": _vm.getDatabot(
                          null,
                          _vm.entity,
                          "note",
                          _vm.sideParam
                        )
                      }
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _c("span", { staticClass: "semibold" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Note")) +
                              "\n                    "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-1" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "third-params-note mb-0",
                              attrs: { prop: "note" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "richtext-note rich-text-style"
                                },
                                [
                                  _c("RichText", {
                                    attrs: {
                                      placeholder: _vm.$t.__(
                                        "common.actions.write_note"
                                      ),
                                      options: _vm.optionsRichText,
                                      "is-custom": true,
                                      "data-bot": _vm.getDatabot(
                                        "editor",
                                        _vm.entity,
                                        "note",
                                        _vm.sideParam
                                      )
                                    },
                                    model: {
                                      value: _vm.note,
                                      callback: function($$v) {
                                        _vm.note = $$v
                                      },
                                      expression: "note"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.paramsConfig.idCode
                ? _c(
                    "el-collapse-item",
                    { attrs: { name: "idCode" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("span", { staticClass: "semibold" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Numéro opportunité")) +
                              "\n                    "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-1" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "paramsSettings.idCode" } },
                            [
                              _c("el-input", {
                                attrs: { autocomplete: "off" },
                                model: {
                                  value: _vm.idCode,
                                  callback: function($$v) {
                                    _vm.idCode = $$v
                                  },
                                  expression: "idCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.paramsConfig.staffs
                ? _c(
                    "el-collapse-item",
                    { attrs: { name: "staff" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("span", { staticClass: "semibold" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Affectation")) +
                              "\n                    "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-1" },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "m-0", attrs: { prop: "owner" } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "gray-100 lh-20",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$l10n.__("Propriétaire")) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("select-input-with-avatar", {
                                staticClass: "wp-10",
                                attrs: {
                                  mode: "edit",
                                  options: _vm.staffList,
                                  value: _vm.owner,
                                  defaultValue: _vm.currentStaff.forename,
                                  displayAvatar: {
                                    onOptions: true,
                                    onSelect: true
                                  }
                                },
                                on: { input: _vm.updateOwner }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "m-0 mt-2",
                              attrs: { prop: "staff" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "gray-100 lh-20",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Collaborateur(s) affecté(s)"
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("select-input-with-avatar", {
                                staticClass: "wp-10",
                                attrs: {
                                  mode: "edit",
                                  options: _vm.staffList,
                                  multiple: true,
                                  value: _vm.staff,
                                  size: "medium",
                                  displayAvatar: {
                                    onOptions: true,
                                    onSelect: false
                                  }
                                },
                                on: { input: _vm.updateStaff }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.paramsConfig.social
                ? _c(
                    "el-collapse-item",
                    {
                      attrs: {
                        name: "social",
                        "data-bot": _vm.getDatabot(
                          null,
                          _vm.entity,
                          "social-networks",
                          _vm.sideParam
                        )
                      }
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _c("span", { staticClass: "semibold" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Réseaux sociaux")) +
                              "\n                    "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-1" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "paramsSettings.social.facebook" }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t.__(
                                    "common.labels.facebook"
                                  ),
                                  autocomplete: "off",
                                  "data-bot": _vm.getDatabot(
                                    "facebook",
                                    _vm.entity,
                                    "social-networks",
                                    _vm.sideParam
                                  )
                                },
                                model: {
                                  value: _vm.facebook,
                                  callback: function($$v) {
                                    _vm.facebook = $$v
                                  },
                                  expression: "facebook"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "paramsSettings.social.twitter" }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t.__(
                                    "common.labels.twitter"
                                  ),
                                  autocomplete: "off",
                                  "data-bot": _vm.getDatabot(
                                    "twitter",
                                    _vm.entity,
                                    "social-networks",
                                    _vm.sideParam
                                  )
                                },
                                model: {
                                  value: _vm.twitter,
                                  callback: function($$v) {
                                    _vm.twitter = $$v
                                  },
                                  expression: "twitter"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "m-0",
                              attrs: { prop: "paramsSettings.social.linkedin" }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t.__(
                                    "common.labels.linkedin"
                                  ),
                                  autocomplete: "off",
                                  "data-bot": _vm.getDatabot(
                                    "linkedin",
                                    _vm.entity,
                                    "social-networks",
                                    _vm.sideParam
                                  )
                                },
                                model: {
                                  value: _vm.linkedin,
                                  callback: function($$v) {
                                    _vm.linkedin = $$v
                                  },
                                  expression: "linkedin"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.paramsConfig.syncProviders && _vm.syncProvidersList.length > 0
                ? _c(
                    "el-collapse-item",
                    {
                      attrs: {
                        name: "syncProviders",
                        "data-bot": _vm.getDatabot(
                          null,
                          _vm.entity,
                          "sync-settings",
                          _vm.sideParam
                        )
                      }
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _c("span", { staticClass: "semibold" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$l10n.__("Paramètres synchronisation")
                              ) +
                              "\n                    "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-1" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "third-params-sync-providers mb-0",
                              attrs: { prop: "sync-providers" }
                            },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  staticClass: "flex-column",
                                  on: { change: _vm.updateSyncProviders },
                                  model: {
                                    value: _vm.syncProvidersDefault,
                                    callback: function($$v) {
                                      _vm.syncProvidersDefault = $$v
                                    },
                                    expression: "syncProvidersDefault"
                                  }
                                },
                                _vm._l(_vm.syncProvidersList, function(
                                  sync,
                                  index
                                ) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: index,
                                      staticClass: "my-1",
                                      attrs: {
                                        "data-bot": _vm.getDatabot(
                                          sync.value,
                                          _vm.entity,
                                          "sync-settings",
                                          _vm.sideParam
                                        ),
                                        checked: sync.is_setup,
                                        label: sync
                                      }
                                    },
                                    [_vm._v(_vm._s(sync.label))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.paramsConfig.marketing
                ? _c(
                    "el-collapse-item",
                    { attrs: { name: "marketing" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("span", { staticClass: "semibold" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Paramètres Marketing")) +
                              "\n                    "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { staticClass: "mb-0", attrs: { prop: "marketing" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              staticClass: "flex-column",
                              on: { change: _vm.updateMarketing },
                              model: {
                                value: _vm.marketing,
                                callback: function($$v) {
                                  _vm.marketing = $$v
                                },
                                expression: "marketing"
                              }
                            },
                            _vm._l(_vm.marketingList, function(param, index) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: index,
                                  staticClass: "my-1",
                                  attrs: {
                                    checked: _vm.marketing[param.code],
                                    label: param
                                  }
                                },
                                [_vm._v(_vm._s(param.label))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.paramsConfig.smarttags
                ? _c(
                    "el-collapse-item",
                    {
                      attrs: {
                        name: "smarttags",
                        "data-bot": _vm.getDatabot(
                          null,
                          _vm.entity,
                          "smart-tags",
                          _vm.sideParam
                        )
                      }
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _c("span", { staticClass: "semibold" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Smart tags")) +
                              "\n                    "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tags",
                        {
                          staticClass: "tags-150 mt-3 smart-tags-input",
                          attrs: {
                            "data-bot": _vm.getDatabot(
                              "editor",
                              _vm.entity,
                              "smart-tags",
                              _vm.sideParam
                            ),
                            linkedtype: _vm.smartTagslinkedType,
                            edit: true,
                            standalone: false,
                            fetchTags: false,
                            options: _vm.getSmartTags,
                            size: "small"
                          },
                          on: { tagsUpdated: _vm.tagsUpdated }
                        },
                        [
                          _c("span", {
                            attrs: { slot: "title" },
                            slot: "title"
                          })
                        ]
                      )
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }